import React, {useEffect, useState, Fragment} from 'react'
import {useStateContext} from '../context/StateContext';
import {VisDiv} from '../components';
import { AiFillExclamationCircle } from 'react-icons/ai';
import { isNonConformitySevere } from '../lib/utils';



/**
 * 
 * #registersDevicesNonConformitiesModule
 * 
 * A component that renders a list of non conformities.
 * @param {Array} nonConformityArray - the array of non conformities to render
 * @param {Function} filter - the filter function to apply to the array
 * @param {Array} visRules - the visibility rules for the component
 * @param {Function} onClick - the function to call when the component is clicked
 * @param {String} title - the title of the component
 * @param {String} titleColor - the color of the title
 * @returns {React.Component} - the component
 */
const ListaNonConformita = ({nonConformityArray, filter, visRules=[], onClick, title, titleColor}) => {
const {setCurrentNonConformity, nonConformities} = useStateContext();
const filteredArray = !Array.isArray(nonConformityArray) ? [] : nonConformityArray.filter?.(filter);
  return (
    <VisDiv className='new-device-container-top' style={{marginTop:"15px", marginBottom:"15px"}} rules={[...visRules, filteredArray?.length>0]}>
    <h2 style={{color: titleColor && titleColor}}>{title}</h2>

    {filteredArray.map?.((item, index)=>{
        const nonConformity = !Array.isArray(nonConformities) ? {} : nonConformities.find?.((x)=>x?._id==item?.nonConformity?._ref)
        const backgroundColor = () => {
            if(item?.status=="ASSEGNATO") return "#FFBF00"
            if(item?.status=="COMPLETATO") return "#00FF00"
        } 
        const nNonConformities = item?.nNonConformities > 1 && ` X${item?.nNonConformities}`
        const onNonConformityClick = () => {
            //console.log("onclick non conf:", item)
            setCurrentNonConformity(item)
        }
        return(
            <div onClick={onNonConformityClick} key={index} className='nonConformity-pin-container' style={{marginTop:"15px", padding:"5px", backgroundColor: backgroundColor()}}> 

                <VisDiv rules={[isNonConformitySevere(item, nonConformities)]}><AiFillExclamationCircle fontSize={21} color='red' /></VisDiv>               
                <div onClick={onClick} className='vlfield-value-container' style={{display:'flex', textAlign:'left'}}>
                    {nonConformity?.label} {nNonConformities}
                </div>

            </div>
        )
    }

    
    )}
</VisDiv>
  )
}

export default ListaNonConformita
